<template>
  <div>
        <banner>
            <div class="huoyuanxx">
                <div style="font-size:36px;">新闻详情</div>
                <div style="margin-top:18px;font-size:18px;line-height:28px;">了解这个行业改变游戏规则的平台如何使托运人和货运代理商能够主动创建和优化可执行的运输计划，<br />
以及将订单或特定订单类型直接发送到特定的承运商和船舶。</div>
            </div>
        </banner>
        <div class="shissjbg"> 
            <div class="details">
                <div class="newstit">{{details.newsTitle}}</div>
                <div class="newsdate">发布日期 :{{datefilter(details.createTime)}}</div>
                <div class="newscont" v-html="details.newsContent">
                    <!-- <p>根据现行疫情情况，结合我单位实际防疫工作需要。现明确进（出）巨力园区（包括巨力索具园区、巨力新能源园区及刘伶醉酒厂区）的外来车辆相关规定如下：</p>
                    <p>1、外来车辆司机需遵守《巨力集团有限公司公司保卫管理规定》，并配合门卫测温消毒登记。</p>
                    <p>2、疫情期间所有司机进入厂区必须佩戴口罩(全程佩戴），司机不得随意下车（除清点货物、过泵、泵房拍照、加固货物、签字等必须下车外），更不得下车随意走动以及人群聚集，要求人与人之间保持1米以上距离，如发现不遵守规定者，将根据实际情况进行最少500元/次的罚款，影响严重者取消其承运资</p>
                    <div>
                        <img src="@/assets/newsimg.jpg" width="100%" />
                    </div>
                    <div>
                        <img src="@/assets/newsimg1.jpg" width="100%" />
                    </div> -->
                </div>
            </div>
      </div>
  </div>
</template>

<script>
import Banner from '../components/banner/banner'
import { newsdetails } from '@/utils/service'
import mymixins from '@/mixins'
export default {
    mixins:[mymixins],
    data(){
        return {
            id:'',
            details:{}
        }
    },
    components:{
        Banner
    },
    methods:{
        // newsdetails(id){
        //     newsdetails({
        //         id
        //     }).then(data => {
        //         this.details = data
        //     })
        // }
    },
    created(){
        let id = this.$route.query.id
        if(id){
            newsdetails({
                id:id
            }).then(data => {
                this.details = data
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
    .huoyuanxx
        padding-top: 80px
        color: #fff
    .shissjbg
        background: #eef6ff
        padding: 50px 0
    .details
        width: 1200px
        margin: 0 auto
        padding:50px
        background: #fff
        .newstit
            margin-bottom: 15px
            font-size:20px
            text-align: center
        .newsdate
            margin-bottom: 40px
            font-size: 16px
            color: #aeacac
            text-align: center
        .newscont
            font-size: 16px
            line-height: 26px
            p
              margin-bottom: 20px
            div
              padding-bottom: 20px
    .chaocyc
        text-overflow: ellipsis
        white-space: nowrap
        overflow: hidden
</style>